import React, { useEffect } from 'react';
import { COMMAND_PALETTE_REGISTRY_IDS } from '@atlassian/jira-command-palette-registry/src/common/constants/registry/index.tsx';
import { useSubscribeCommands } from '@atlassian/jira-command-palette-registry/src/controllers/use-subscribe-commands/index.tsx';
import { QuickSearchWrapper } from '../controllers/use-quick-search-analytics/wrapper/index.tsx';
import { useQuickSearchCommand } from './use-quick-search-command/index.tsx';

const useQuickSearchCommands = () => {
	const subscribe = useSubscribeCommands();
	const { quickSearchCommand } = useQuickSearchCommand({ keepSearch: false });

	useEffect(
		() => subscribe(COMMAND_PALETTE_REGISTRY_IDS.QUICK_SEARCH, [quickSearchCommand]),
		[quickSearchCommand, subscribe],
	);

	return null;
};

const QuickSearchCommandsInner = () => {
	useQuickSearchCommands();
	return null;
};

export const QuickSearchCommands = (): React.JSX.Element => (
	<QuickSearchWrapper>
		<QuickSearchCommandsInner />
	</QuickSearchWrapper>
);
